import dayjs from 'dayjs';

import {
  LoginForm,
} from '@/components';

export default {
  name: 'Login',
  components: {
    LoginForm,
  },
  computed: {
    currentYear() {
      return dayjs().format('YYYY');
    },
  },
};
